<script>
    import SelectorWidget from './SelectorWidget';

    export default {
        extends: SelectorWidget,
        methods: {
            render() {
                this.iteration += 1;
                this.setValue();
            }
        }
    }
</script>
